import { gsap } from 'gsap';

const Animation = {
  mutations: {
    'ANIMATION/TOP_SECTION': function() {
      const tl = gsap.timeline();
      tl.fromTo(
        '.bg-effect-2',
        { opacity: 0 },
        { opacity: 1, duration: 0.3, ease: 'power1.out' },
        0.5,
      );
      tl.fromTo(
        '.white-hair',
        { opacity: 0, y: 100 },
        { opacity: 1, y: 0, duration: 1, ease: 'circ.out' },
        1,
      );
      tl.fromTo(
        '.black-hair',
        { opacity: 0, x: -100 },
        { opacity: 1, x: 0, duration: 1, ease: 'circ.out' },
        1.5,
      );
      tl.fromTo(
        '.devil',
        { opacity: 0, x: -100 },
        { opacity: 1, x: 0, duration: 1, ease: 'circ.out' },
        1.5,
      );
      tl.fromTo(
        '.red-hair',
        { opacity: 0, x: 100 },
        { opacity: 1, x: 0, duration: 1, ease: 'circ.out' },
        1.5,
      );
      tl.fromTo(
        '.chain-effect',
        { opacity: 0, x: 100 },
        { opacity: 1, x: 0, duration: 1.2, ease: 'circ.out' },
        1.5,
      );
      tl.fromTo(
        '.fire-effect',
        { opacity: 0, x: 100 },
        { opacity: 1, x: 0, duration: 1.2, ease: 'circ.out' },
        1.5,
      );
      tl.fromTo(
        '.fairy',
        { opacity: 0, y: -100 },
        { opacity: 1, y: 0, duration: 1, ease: 'circ.out' },
        2,
      );
      tl.fromTo(
        '.flower-1',
        { opacity: 0 },
        { opacity: 1, duration: 1, ease: 'circ.out' },
        2.3,
      );
      tl.fromTo(
        '.flower-2',
        { opacity: 0, scale: 0 },
        { opacity: 1, scale: 1, duration: 0.5, ease: 'circ.out' },
        2.6,
      );
      tl.fromTo(
        '.flower-7',
        { opacity: 0, scale: 0 },
        { opacity: 1, scale: 1, duration: 0.5, ease: 'circ.out' },
        2.9,
      );
      tl.fromTo(
        '.flower-3',
        { opacity: 0, scale: 0 },
        { opacity: 1, scale: 1, duration: 0.5, ease: 'circ.out' },
        3.2,
      );
      tl.fromTo(
        '.flower-4',
        { opacity: 0, scale: 0 },
        { opacity: 1, scale: 1, duration: 0.5, ease: 'circ.out' },
        3.5,
      );
      tl.fromTo(
        '.flower-5',
        { opacity: 0, scale: 0 },
        { opacity: 1, scale: 1, duration: 0.5, ease: 'circ.out' },
        3.8,
      );
      tl.fromTo(
        '.bg-effect-1',
        { opacity: 0 },
        { opacity: 1, duration: 1, ease: 'circ.out' },
        3.8,
      );
      tl.fromTo(
        '.flower-6',
        { opacity: 0, scale: 0 },
        { opacity: 1, scale: 1, duration: 0.5, ease: 'circ.out' },
        4.1,
      );
      tl.fromTo(
        '.logo',
        { opacity: 0 },
        { opacity: 1, duration: 1, ease: 'circ.out' },
        2.9,
      );
      tl.fromTo(
        '.play-btn',
        { opacity: 0 },
        { opacity: 1, duration: 1.3, ease: 'circ.out' },
        4,
      );
    },
    'ANIMATION/INIT_MAP_SECTION': function() {
      const tl = gsap.timeline();
      tl.fromTo(
        '.map-type-wrapper',
        { y: 80 },
        { opacity: 1, y: 0, duration: 0.5, ease: 'circ.out' },
        0.5,
      );
      tl.fromTo(
        '.map-title',
        { y: 80 },
        { opacity: 1, y: 0, duration: 0.5, ease: 'circ.out' },
        0.6,
      );
      tl.fromTo(
        '.map-image',
        { y: 80 },
        { opacity: 1, y: 0, duration: 0.5, ease: 'circ.out' },
        0.7,
      );
      tl.fromTo(
        '.story-wrapper:nth-child(1)',
        { y: 80 },
        { opacity: 1, y: 0, duration: 0.5, ease: 'circ.out' },
        0.8,
      );
      tl.fromTo(
        '.story-wrapper:nth-child(2)',
        { y: 80 },
        { opacity: 1, y: 0, duration: 0.5, ease: 'circ.out' },
        0.9,
      );
    },
    'ANIMATION/RESET_MAP_SECTION': function() {
      const tl = gsap.timeline();
      tl.set('.map-type-wrapper', { opacity: 0 });
      tl.set('.map-title', { opacity: 0 });
      tl.set('.map-image', { opacity: 0 });
      tl.set('.story-wrapper:nth-child(1)', { opacity: 0 });
      tl.set('.story-wrapper:nth-child(2)', { opacity: 0 });
    },

    'ANIMATION/INIT_BOSS_SECTION': function() {
      const tl = gsap.timeline();
      tl.fromTo(
        '.boss-img',
        { x: 100 },
        { opacity: 1, x: 0, duration: 0.5, ease: 'circ.out' },
        0.5,
      );
      tl.fromTo(
        '.boss-name',
        { x: 100 },
        { opacity: 1, x: 0, duration: 0.5, ease: 'circ.out' },
        1,
      );
      tl.fromTo(
        '.boss-subtitle',
        { x: 100 },
        { opacity: 1, x: 0, duration: 0.5, ease: 'circ.out' },
        1.5,
      );
      tl.fromTo(
        '.boss-desc',
        { x: 100 },
        { opacity: 1, x: 0, duration: 0.5, ease: 'circ.out' },
        2,
      );
    },
    'ANIMATION/RESET_BOSS_SECTION': function() {
      const tl = gsap.timeline();
      tl.set('.boss-img', { opacity: 0 });
      tl.set('.boss-name', { opacity: 0 });
      tl.set('.boss-subtitle', { opacity: 0 });
      tl.set('.boss-desc', { opacity: 0 });
    },
    'ANIMATION/INIT_MONSTER_SECTION': function() {
      const tl = gsap.timeline();
      tl.fromTo(
        '.monster-img',
        { x: 100 },
        { opacity: 1, x: 0, duration: 0.5, ease: 'circ.out' },
        0.5,
      );
      tl.fromTo(
        '.monster-name',
        { x: 100 },
        { opacity: 1, x: 0, duration: 0.5, ease: 'circ.out' },
        1,
      );
      tl.fromTo(
        '.monster-desc',
        { x: 100 },
        { opacity: 1, x: 0, duration: 0.5, ease: 'circ.out' },
        1.5,
      );
    },
    'ANIMATION/RESET_MONSTER_SECTION': function() {
      const tl = gsap.timeline();
      tl.set('.monster-img', { opacity: 0 });
      tl.set('.monster-name', { opacity: 0 });
      tl.set('.monster-desc', { opacity: 0 });
    },
    'ANIMATION/RESET_CHAMP_SECTION': function() {
      const tl = gsap.timeline();
      tl.set('.champ-name', { opacity: 0 });
      tl.set('.champ-subtitle', { opacity: 0 });
      tl.set('.champ-desc', { opacity: 0 });
      tl.set('.champ-img', { opacity: 0 });
    },
    'ANIMATION/INIT_CHAMP_SECTION': function() {
      const tl = gsap.timeline();
      tl.fromTo(
        '.champ-name',
        { x: -80 },
        { opacity: 1, x: 0, duration: 0.5, ease: 'circ.out' },
        0.5,
      );
      tl.fromTo(
        '.champ-subtitle',
        { x: -80 },
        { opacity: 1, x: 0, duration: 0.5, ease: 'circ.out' },
        1,
      );
      tl.fromTo(
        '.champ-desc',
        { x: -80 },
        { opacity: 1, x: 0, duration: 0.5, ease: 'circ.out' },
        1.5,
      );
      tl.fromTo(
        '.champ-img',
        { x: -80 },
        { opacity: 1, x: 0, duration: 0.5, ease: 'circ.out' },
        1.5,
      );
    },
    'ANIMATION/RESET_NPC_SECTION': function() {
      const tl = gsap.timeline();
      tl.set('.npc-name', { opacity: 0 });
      tl.set('.npc-subtitle', { opacity: 0 });
      tl.set('.npc-desc', { opacity: 0 });
      tl.set('.npc-img', { opacity: 0 });
    },
    'ANIMATION/INIT_NPC_SECTION': function() {
      const tl = gsap.timeline();
      tl.fromTo(
        '.npc-img',
        { x: -80 },
        { opacity: 1, x: 0, duration: 0.5, ease: 'circ.out' },
        0.5,
      );
      tl.fromTo(
        '.npc-name',
        { x: -80 },
        { opacity: 1, x: 0, duration: 0.5, ease: 'circ.out' },
        1,
      );
      tl.fromTo(
        '.npc-subtitle',
        { x: -80 },
        { opacity: 1, x: 0, duration: 0.5, ease: 'circ.out' },
        1.5,
      );
      tl.fromTo(
        '.npc-desc',
        { x: -80 },
        { opacity: 1, x: 0, duration: 0.5, ease: 'circ.out' },
        2,
      );
    },
  },
};

export default Animation;
